import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  invoiceContainer: {
    maxWidth: '1200px',
    margin: '20px auto',
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    padding: '40px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    color: '#333',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  invoiceHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '30px',
    borderBottom: '3px solid #1976d2',
    paddingBottom: '20px',
  },
  receiptIcon: {
    width: '40px',
    height: '40px',
    background: '#1976d2',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '20px',
    marginRight: '15px',
  },
  headerText: {
    flex: 1,
    '& h1': {
      fontSize: '28px',
      color: '#1976d2',
      margin: '0 0 5px 0',
      fontWeight: 'bold',
    },
    '& p': {
      color: '#666',
      fontSize: '16px',
      margin: 0,
    },
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '20px',
    marginBottom: '30px',
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
    },
  },
  infoCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '20px',
    '& h3': {
      color: '#1976d2',
      marginBottom: '15px',
      fontSize: '18px',
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
    },
    '& p': {
      marginBottom: '8px',
      lineHeight: 1.5,
    },
  },
  status: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    marginTop: '8px',
  },
  activeStatus: {
    background: '#e8f5e9',
    color: '#2e7d32',
  },
  canceledStatus: {
    background: '#ffebee',
    color: '#c62828',
  },
  invoiceTable: {
    width: '100%',
    borderCollapse: 'collapse',
    marginBottom: '30px',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    '& thead tr': {
      background: '#f8f9fa',
      fontWeight: 600,
      color: '#333',
    },
    '& th, & td': {
      padding: '15px',
      textAlign: 'left',
      borderBottom: '1px solid #e0e0e0',
    },
  },
  textCenter: {
    textAlign: 'center',
  },
  textRight: {
    textAlign: 'right',
  },
  dayList: {
    fontSize: '12px',
    color: '#666',
    marginTop: '5px',
    display: 'block',
  },
  paymentSummary: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '20px',
    marginBottom: '30px',
    '& h3': {
      marginBottom: '20px',
      color: '#1976d2',
    },
  },
  summaryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  totalRow: {
    borderTop: '2px solid #e0e0e0',
    paddingTop: '15px',
    marginTop: '15px',
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1976d2',
  },
  invoiceFooter: {
    textAlign: 'center',
    paddingTop: '20px',
    borderTop: '1px solid #e0e0e0',
    color: '#666',
    fontSize: '12px',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
    fontSize: '18px',
  },
  error: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
    fontSize: '18px',
    color: '#f44336',
  },
  empty: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '400px',
    fontSize: '18px',
    color: '#666',
  },
  cancellationSection: {
  marginLeft: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: theme.spacing(1),
},
cancelButton: {
  backgroundColor: theme.palette.error.main,
  color: theme.palette.error.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.error.dark,
  },
},
cancellationMessage: {
  fontWeight: 'bold',
},
dayList: {
  fontSize: '12px',
  color: '#666',
  marginTop: '5px',
  display: 'block',
}
}));

export default useStyles;